import { ReleaseRef } from 'hooks/data/versions/types';

import { DatasetRef } from './types';

/** Stable string form of a DatasetRef, for map keys, React keys and comparison. */
export const datasetRefKey = ({ id, version, systemModel }: DatasetRef): string => `${version}|${systemModel}|${id}`;

export const isSameDatasetRef = (a: DatasetRef, b: DatasetRef): boolean => datasetRefKey(a) === datasetRefKey(b);

export const isSameRelease = (a: DatasetRef, b: DatasetRef): boolean =>
  a.version === b.version && a.systemModel === b.systemModel;

/** Cutoff vs consequential is not a sound comparison, so this is checked separately from the version. */
export const isSameSystemModel = (a: DatasetRef, b: DatasetRef): boolean => a.systemModel === b.systemModel;

/** DatasetRef (camelCase, UI shape) -> ReleaseRef (snake_case, API and query-key shape). */
export const toReleaseRef = ({ version, systemModel }: DatasetRef): ReleaseRef => ({
  version,
  system_model: systemModel,
});
